import { get, post } from '../http';

const fetch = () => get('settingsRetrieve');
const save = (id, data) => {
  let url = 'settingSave';
  if (id) {
    url += '?id=' + id;
  }
  return post(url, data);
};

export default {
  fetch,
  save,
};
